module.exports = __webpack_public_path__ + "img/app-live-speaking.bcfcd4b7.png";